import { render, staticRenderFns } from "./DeviceDecommissioned.vue?vue&type=template&id=138c2ef2&"
import script from "./DeviceDecommissioned.vue?vue&type=script&lang=js&"
export * from "./DeviceDecommissioned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports